import {
  animate,
  state,
  style,
  transition,
  trigger,
} from "@angular/animations";
import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  Input,
  ViewChild,
} from "@angular/core";
import { IButtonData } from "src/app/dynamic-module/lib/public_api";
import { IUProperty } from "src/app/shared/interface/umbraco-property";
import { applyRteSettings } from '../../../../shared/utils/rte-style-settings-utils';
import { IRteStyleSettings } from '../../../../shared/interface/rte-style-settings';

export interface IFAQImageItem {
  answer: IUProperty<any>;
  question: IUProperty<string>;
  link?: IUProperty<IButtonData>;
  state?: string;
  anchor?: IUProperty<string>;
  headlineSize?: IUProperty<string>;
  questionColor?: IUProperty<string>;
  answerColor?: IUProperty<string>;
  id: number;

  rteStyleSettings?: IRteStyleSettings;
}

export enum AccordionItemState {
  opened = "opened",
  closed = "closed",
}

@Component({
  selector: "app-faq-image-panel-item",
  templateUrl: "./faq-image-panel-item.component.html",
  styleUrls: ["./faq-image-panel-item.component.less"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    trigger("animation", [
      state(
        "opened",
        style({
          height: "*",
          opacity: "1",
        })
      ),
      state(
        "closed",
        style({
          height: "0",
          opacity: "0",
          paddingBottom: "0",
          paddingTop: "0",
        })
      ),
      transition("* => *", [animate(".2s")]),
    ]),
  ],
})
export class FaqImagePanelItemComponent implements AfterViewInit {
  @Input() item: IFAQImageItem;
  @ViewChild('itemDisc', { static: false }) itemDiscEl: ElementRef<HTMLElement>;

  accordionItemState = AccordionItemState;

  constructor(private hostRef: ElementRef) {}

  ngAfterViewInit(): void {
    this.setCustomThemeProperties(this.item);
  }

  handleToggleItem(item: any) {
    if (item.state === AccordionItemState.opened) {
      item.state = this.accordionItemState.closed;
    } else {
      item.state = this.accordionItemState.opened;
    }
  }

  private setCustomThemeProperties(d: IFAQImageItem) {
    if (d.answerColor && d.answerColor.value) {
      this.hostRef.nativeElement.style.setProperty(
        "--faq-answer-color",
        d.answerColor.value
      );
    }

    if (d.headlineSize && d.headlineSize.value) {
      this.hostRef.nativeElement.style.setProperty(
        "--faq-headline-size",
        d.headlineSize.value
      );
    }

    if (d.questionColor && d.questionColor.value) {
      this.hostRef.nativeElement.style.setProperty(
        "--faq-question-color",
        d.questionColor.value
      );
    }
    applyRteSettings(this.item, this.itemDiscEl);
  }
}
